const CONTACT_FORM_HASH_REGEX = /#contact-form(?:__(.+))?$/;

export const isContactFormURL = (url: string) => CONTACT_FORM_HASH_REGEX.test(url);

export const getContactFormSlugFromUrl = (url?: string) => {
  if (!url) {
    return undefined;
  }

  const match = url.match(CONTACT_FORM_HASH_REGEX);
  return match?.[1];
};
